/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';
import { addDays } from 'date-fns';

function prepareCalendarData() {
  const now = new Date();
  const rows = [];
  for (let i = 365; i > 0; i--) {
    const date = addDays(now, -i);
    rows.push({
      date: date.toISOString().substring(0, 10),
      value: Math.round(Math.random() * 100),
    });
  }
  return JSON.stringify(rows);
}

const page: {
  root: Item<'Page'>;
  flexItem1: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  localDataStore: Item<'LocalDataStore'>;
  calendarHeatmap: Item<'CalendarHeatmap'>;
  dataStoreReference: Item<'DataStoreReference'>;
} = {
  calendarHeatmap: {
    children: [],
    itemId: 'calendarHeatmap',
    parent: 'flexItem1',
    props: {
      comboDatasourceAlias: 'test',
      dateAttribute: 'date',
      valueAttribute: 'value',
    },
    type: 'CalendarHeatmap',
  },
  dataStoreReference: {
    children: ['flexPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'test',
    },
    type: 'DataStoreReference',
  },
  flexItem1: {
    children: ['calendarHeatmap'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem1'],
    itemId: 'flexPanel',
    parent: 'dataStoreReference',
    props: {},
    type: 'FlexPanel',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData: prepareCalendarData(),
      singleton: true,
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
};

export const helpRenders: ComponentSample<'CalendarHeatmap'>[] = [
  {
    title: 'Calendar Heatmap',
    description:
      'A Local Data Store populated by random data with a value ranging between 0 & 100 is used to render the below heatmap. Try changing the Color 1..4 Max Value prop to see how the heatmap behaves.',
    page,
    exampleId: 'e1',
    clearParentChildren: true,
    height: 280,
    visibleProps: [
      'color1MaxValue',
      'color2MaxValue',
      'color3MaxValue',
      'color4MaxValue',
    ],
    item: {
      children: [],
      itemId: 'calendarHeatmap',
      parent: 'flexItem1',
      props: {
        comboDatasourceAlias: 'test',
        dateAttribute: 'date',
        valueAttribute: 'value',
        color1MaxValue: 20,
        color2MaxValue: 40,
        color3MaxValue: 60,
        color4MaxValue: 80,
      },
      type: 'CalendarHeatmap',
    },
  },
  {
    title: 'Labels',
    page,
    exampleId: 'e2',
    clearParentChildren: true,
    height: 280,
    visibleProps: [
      'showMonthLabels',
      'showWeekdayLabels',
      'showOutOfRangeDays',
    ],
    item: {
      children: [],
      itemId: 'calendarHeatmap',
      parent: 'flexItem1',
      props: {
        comboDatasourceAlias: 'test',
        dateAttribute: 'date',
        valueAttribute: 'value',
        color1MaxValue: 20,
        color2MaxValue: 40,
        color3MaxValue: 60,
        color4MaxValue: 80,
      },
      type: 'CalendarHeatmap',
    },
  },
  {
    title: 'Date Range',
    page,
    exampleId: 'e3',
    clearParentChildren: true,
    height: 280,
    visibleProps: ['fromDateRange', 'toDateRange'],
    item: {
      children: [],
      itemId: 'calendarHeatmap',
      parent: 'flexItem1',
      props: {
        comboDatasourceAlias: 'test',
        dateAttribute: 'date',
        valueAttribute: 'value',
        color1MaxValue: 20,
        color2MaxValue: 40,
        color3MaxValue: 60,
        color4MaxValue: 80,
        fromDateRange: -90,
        toDateRange: 0,
      },
      type: 'CalendarHeatmap',
    },
  },
];
